import React from "react";

import { CSSGrid } from "@components/Layout/CssGrid";
import { Section } from "@components/Layout/Section";
import { Container } from "@components/Layout/Container";

import * as Styled from "./Extras.styled";
import { Header } from "./Header";
import { Tabs } from "./Tabs";

const header = CSSGrid.areas({
  Header,
});

header.all(({ Header }, { repeat }) => [repeat(Header, 12)]);

header.smallTablet(({ Header }, { repeat }) => [repeat(Header, 9)]);

export const Extras: React.FC = () => {
  return (
    <Section color="white" backgroundColor="blue500" overflowHidden>
      <Container>
        <Styled.Root>
          <CSSGrid areas={header} />

          <Tabs />
        </Styled.Root>
      </Container>
    </Section>
  );
};
